import { array } from 'prop-types';

export default function returnUniqueValues({
  prev = [],
  next = [],
  sortBy = 'id',
  sortFn = (a, b) => a.id - b.id,
}) {
  const uniqueMap = new Map(prev.map((item) => [item[sortBy], item]));

  next.forEach((item) => {
    if (!uniqueMap.has(item[sortBy])) {
      uniqueMap.set(item[sortBy], item);
    }
  });

  return Array.from(uniqueMap.values()).sort(sortFn);
}

export function mergeAndSortArrays(arr1, arr2, fieldToMerge = 'code') {
  // Combine the arrays
  const combinedArray = [...arr1, ...arr2];

  // Remove duplicates based on the 'fieldToMerge' field
  const uniqueArray = combinedArray.reduce((acc, obj) => {
    const existingObj = acc.find(
      (item) => item[fieldToMerge] === obj[fieldToMerge]
    );
    if (!existingObj) {
      acc.push(obj);
    }
    return acc;
  }, []);

  // Sort the array with the specified criteria
  const sortedArray = uniqueArray.sort((a, b) => {
    if (arr1.includes(a) && arr1.includes(b)) {
      // If both objects are from arr1, maintain their original order
      return arr1.indexOf(a) - arr1.indexOf(b);
    } else if (arr1.includes(a)) {
      // If only object a is from arr1, place it before b
      return -1;
    } else if (arr1.includes(b)) {
      // If only object b is from arr1, place it after a
      return 1;
    } else {
      return arr2.indexOf(a) - arr2.indexOf(b);
    }
  });

  return sortedArray;
}
